import { render, staticRenderFns } from "./TestGroupStatus.vue?vue&type=template&id=3649000c&scoped=true&"
import script from "./TestGroupStatus.vue?vue&type=script&lang=ts&"
export * from "./TestGroupStatus.vue?vue&type=script&lang=ts&"
import style0 from "./TestGroupStatus.vue?vue&type=style&index=0&id=3649000c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3649000c",
  null
  
)

export default component.exports